export default "__VITE_ASSET__Buf0p3TF__"